export const selectStyles = {
    control: (provided, state) => ({
        ...provided,
        fontSize: '14px',
        height: '38px',
        color: '#444444',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: state.isFocused ? '#47E5EB' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #47E5EB' : null,
        '&:hover': {
            borderColor: state.isFocused ? '#47E5EB' : '#ccc'
        },
        cursor: 'pointer',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#47E5EB' : 'white',
        color: state.isSelected ? 'white' : 'black',
        '&:hover': {
            backgroundColor: state.isSelected ? '#47E5EB' : '#46e6ec33'
        },
        padding: '3px 18px',
        fontSize: '16px',
        cursor: 'pointer',
    }),
    placeholder: (provided) => ({
        ...provided,
        fontSize: '14px',
        color: '#444444',
    })
}